export default __webpack_public_path__ + "static/media/notification.4e1a498a.svg";